
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/e-commerce",
      function () {
        return require("private-next-pages/services/e-commerce.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/e-commerce"])
      });
    }
  